import React from 'react';
import useStyles from './styles';
import { useStore } from 'src/stores';
import { TagModal } from '../TagModal';
import { observer } from 'mobx-react-lite';
export const TagUnits = observer(_ref => {
  let tags = _ref.tags,
    companyId = _ref.companyId,
    trigger = _ref.trigger;
  const store = useStore();
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, tags && tags.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, tags.map(i => {
    if (store.tags.getTagById(i)) {
      return /*#__PURE__*/React.createElement("span", {
        className: classes.unit,
        style: {
          backgroundColor: store.tags.getTagById(i).color
        }
      }, store.tags.getTagById(i).name);
    }
  })), /*#__PURE__*/React.createElement(TagModal, {
    companyId: companyId,
    tags: tags,
    trigger: trigger
  }));
});